import '../styles/popup.scss';
import { useState, useEffect } from 'react';

export const PopUpMessage = () => {
  const [ popUp, setPopUp ]  = useState(false);

  useEffect(() => {
    setTimeout(
      () => setPopUp(true),
      5000
    )
  }, []);

  const close = () => setPopUp(false);
 
  return (
    <>
      {popUp ? 
        <div className='pop-up'>
          <div className='pop-up-box'>
            <div className='img-pop-up'></div>
            <div className='content-pop-up'>
              <div className='pop-up-btn'>
                <button onClick={close}>X</button>
              </div>
              <div className='text-pop-up'>
              <span className="tag">PROM 2026</span>
<h3>Look Sharp. Stand Out.</h3>
<p className="price">Tuxedos from <strong>$190</strong></p>
<p className="sub">Limited availability — book yours now</p>
              </div>
            </div>
          </div>
        </div> 
      : null}
    </>
  );
};
